import { UPDATE_LOCALE } from '../actions/preferences';

const defaultState = {
  locale: 'en-CA'
};

export default function preferences(state = defaultState, action) {
  switch (action.type) {
    case UPDATE_LOCALE:
      return {
        ...state,
        locale: action.locale
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/preferences.js